$(document).ready(function () {

    // Load More Case Studies Button functionality.

    // Define the options object with selectors and onSuccess callback.
    const caseStudiesAjaxOptions = {
        listSelector:       '.js-case-studies-wrapper',
        buttonsSelector:    '.case-studies__buttons',
        buttonsResponseKey: 'case_study_buttons',
        onSuccess:          triggerCaseStudiesCarousel,
    };

    // Filter posts by category
    $('.js-case-study-category').on('click', function () {
        var category = $(this).attr('data_slug');

        $('.js-case-study-category').removeClass('active');
        $(this).addClass('active');

        load_posts_ajax($('.js-view-more-case-studies'), {
            action: 'filter_case_studies',
            category: category
        }, 'replace', caseStudiesAjaxOptions);
    });

    // Load more posts
    $('.case-studies__buttons').on('click', '.js-view-more-case-studies', function () {
        var category = $('.js-case-study-category.active').attr('data_slug') || '';

        load_posts_ajax($(this), {
            action: 'load_more_case_studies',
            category: category
        }, 'append', caseStudiesAjaxOptions);
    });


    /*Carousel Blocks*/
    var slider = $('.js-case-studies-slider');
    var pagination = $('.js-case-studies-pagination');

    slider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        if (!slick.$dots) {
            return;
        }

        var i = (currentSlide ? currentSlide : 0) + 1;
        pagination.text(i + '/' + (slick.$dots[0].children.length));
    });

    slider.slick({
        infinite: true,
        speed: 300,
        arrows: true,
        dots: true,
        slidesToShow: 1,
        prevArrow: '<div class="prev-arrow"><img src="' + ajax_object.theme_url + '/static/images/carousel-arrow-left-green.svg" alt="prev arrow"></div>',
        nextArrow: '<div class="next-arrow"><img src="' + ajax_object.theme_url + '/static/images/carousel-arrow-right-green.svg" alt="next arrow"></div>',
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: "unslick"
            }
        ]
    });


    /* Featured Slider Block */
    const $featuredSlider = $('.js-featured-case-studies-slider');
    const $pagination = $('.js-featured-case-studies-pagination');
    const $paginationText = $pagination.find('.featured-case-studies-slider__pagination__text');

    $featuredSlider.on('init reInit afterChange', function (event, slick, currentSlide) {
        // Add 'scale-up' to the current slide for the scale animation
        $(this)
            .find('.case-study__item:not(.slick-cloned)')
            .eq(slick.currentSlide)
            .addClass('scale-up');

        if (!slick.$dots) {
            return;
        }

        const i = (currentSlide || 0) + 1;
        const totalSlides = slick.$dots[0].children.length;
        $paginationText.html(`${i}/${totalSlides}`);
    });

    /**
     * Remove the 'scale-up' class from all slides before the slide changes 
     * to ensure only the active slide has the animation.
     *
     * Doing this in the 'beforeChange' event prevents any jarring jumps
     * when animating the scale back down, which has something to do with 
     * the way Slick clones slides for the carousel effect.
     */
    $featuredSlider.on('beforeChange', function (event, slick, currentSlide) {
        $(this).find('.case-study__item').removeClass('scale-up');
    });

    $featuredSlider.slick({
        infinite: true,
        speed: 500,
        arrows: true,
        dots: true,
        slidesToShow: 1,
        centerMode: true,
        centerPadding: '15%',
        appendArrows: $pagination,

        prevArrow: '<div class="prev-arrow"><img src="' + ajax_object.theme_url + '/static/images/carousel-arrow-left-green.svg" alt="prev arrow"></div>',
        nextArrow: '<div class="next-arrow"><img src="' + ajax_object.theme_url + '/static/images/carousel-arrow-right-green.svg" alt="next arrow"></div>',

        mobileFirst: true,
    });

    /*
     * Case Study Results Graph
     */

    // Align the graph header title with the chart area's left edge.
    // chart.chartArea.left accounts for y-axis label width dynamically,
    // so padding stays correct whether or not a y-axis label is set.
    var $canvas = $('.js-graph');
    if ($canvas.length) {
        var chart = Chart.getChart($canvas[0]);
        if (chart) {
            var header = $canvas[0].closest('.graph-interactive').querySelector('.graph-interactive__header');
            if (header) {
                header.style.paddingLeft = chart.chartArea.left + 'px';
            }
        }
    }

    
    // Isolate mode: clicking a legend item shows only that dataset and dims the others.
    // Clicking the active item again restores all datasets.
    // This approach also prevents an empty chart — at least one dataset is always visible.
    $(".js-graph-legend").find('.legend__item').on('click', function() {
        const chart = Chart.getChart($('.js-graph')[0]);
        if (!chart) return;

        const $items = $(".js-graph-legend").find('.legend__item');
        const clickedIndex = parseInt($(this).attr('data-index'));

        // Check if clicked dataset is already the only one visible (already isolated)
        const isIsolated = chart.data.datasets.every((_, i) =>
            i === clickedIndex ? chart.isDatasetVisible(i) : !chart.isDatasetVisible(i)
        );


        // If already isolated, restore all datasets and reset legend styles.
        if (isIsolated) {
            chart.data.datasets.forEach((_, i) => chart.show(i));
            $items.css('opacity', '1').removeClass('active');
        }
        // Otherwise, isolate the clicked dataset, dim and deactivate all others
        else {
            chart.data.datasets.forEach((_, i) => {
                if (i === clickedIndex) {
                    chart.show(i);
                } else {
                    chart.hide(i);
                }
            });
            $items.css('opacity', '0.4').removeClass('active');
            $(this).css('opacity', '1').addClass('active');
        }
    });
});